import { Capacitor } from '@capacitor/core';
import { isNativeApp } from './platform';

/**
 * Status bar sits above the WebView (no overlay). Matches MainActivity
 * WindowCompat.setDecorFitsSystemWindows(true).
 */
export async function initNativeChrome() {
  if (!isNativeApp()) return;

  try {
    if (Capacitor.getPlatform() === 'android') {
      const { StatusBar, Style } = await import('@capacitor/status-bar');
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#007a4d' });
      await StatusBar.setStyle({ style: Style.Dark });
      try { await StatusBar.show(); } catch { /* already visible */ }
    }
  } catch (e) {
    console.warn('StatusBar init failed', e?.message || e);
  }
}
